import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { AreaComumUnidadeBloqueioForm } from "core/features/area-comum/typings";
import moment from "moment";
import { Modal } from "antd";
import FooterModal from "ui/components/Button/FooterModal";
import FormBloqueio from "./FormBloqueio";
import { TipoDestinoEnum } from "core/features/documentos/enums";
import useBloquearUnidade from "core/features/area-comum/hooks/useBloquearUnidade";
import useDetalheBloqueioUnidade from "core/features/area-comum/hooks/useDetalheBloqueioUnidade";
import { useLoading } from "components/GlobalLoading";

interface ModalBloqueioUnidadeAreaComumProps {
  visible: boolean;
  onClose: () => any;
  onSaved?: () => any;
  editId?: string;
}

const defaultValues: Partial<AreaComumUnidadeBloqueioForm> = {
  dataInicio: moment().format("YYYY-MM-DD"),
  destinos: [],
  tipoDestinoId: TipoDestinoEnum.UmaUnidade,
  motivo: "",
};

function ModalBloqueioUnidadeAreaComum({
  visible,
  onClose,
  onSaved,
  editId,
}: ModalBloqueioUnidadeAreaComumProps) {
  const { mutate: bloquearUnidade, isLoading: isLoadingSave } =
    useBloquearUnidade();
  const {
    control,
    setValue,
    watch,
    formState,
    reset,
    handleSubmit,
    getValues,
    trigger,
  } = useForm<AreaComumUnidadeBloqueioForm>({
    defaultValues,
    mode: "all",
  });

  const form = watch();

  const onSubmit = (data: AreaComumUnidadeBloqueioForm) => {
    bloquearUnidade(data, {
      onSuccess: onSaved,
    });
  };

  const {
    data: detalhe,
    isLoading: isLoadingDetalhe,
    isFetching: isFetchingDetalhe,
  } = useDetalheBloqueioUnidade(editId);

  useEffect(() => {
    if (!visible) {
      reset(defaultValues);
    }
  }, [reset, visible]);

  useEffect(() => {
    if (detalhe) {
      reset({
        ...detalhe,

        tipoDestinoId: detalhe.destinos.length
          ? TipoDestinoEnum.UmaUnidade
          : TipoDestinoEnum.TodasUnidades,
      });
    }
  }, [detalhe, reset]);
  useLoading(isLoadingDetalhe || isFetchingDetalhe);

  return (
    <Modal
      visible={visible}
      title={"Bloquear unidades"}
      onCancel={onClose}
      width={"700px"}
      destroyOnClose
      footer={
        <FooterModal
          primaryButtonText="Salvar alterações"
          isDisabled={!formState.isValid || isLoadingSave}
          onClose={onClose}
          isLoadingSave={isLoadingSave}
          onSubmit={handleSubmit(onSubmit)}
          showRegisterAnother={false}
          registerAnother={false}
        />
      }
    >
      <FormBloqueio
        control={control}
        getValues={getValues}
        setValue={setValue}
        form={form}
        trigger={trigger}
      />
    </Modal>
  );
}

export default ModalBloqueioUnidadeAreaComum;
